import { Modal } from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";
import RejectReasonModal from "./rejectReason";

interface CustomerDocumentModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function DietaryRequirements({
  open,
  onClose,
  setOpen,
}: CustomerDocumentModalProps) {
  const [open1, setOpen1] = useState(false);
  const handleCloseModal1 = () => {
    setOpen1(false);
  };
  const [reason, setReason] = useState("");

  return (
    <>
      <Modal
        className="modal customerDocument_modal"
        open={open}
        onClose={onClose}
      >
        <div className="modal-dialog">
          <div className="modal-body">
            <div className="modal_title">
              <h2>Dietary Requirements</h2>
              <div
                role="button"
                tabIndex={0}
                className="btn-close"
                onClick={() => setOpen(false)}
              >
                <CloseIcon />
              </div>
            </div>
            <ul className="requirement_list">
              <li>Vegetarian </li>
              <li>Paleo  </li>
              <li>Gluten-Free </li>
              <li>Vegetarian  </li>

            </ul>

          </div>
        </div>
      </Modal>


    </>
  );
}
